/* eslint-disable jira/react/no-style-attribute, @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/enforce-style-prop */
import React, { useEffect, useState } from 'react';
import { useIsHydrateRenderMode } from '@atlassian/jira-ssr-controller/src/use-is-page-hydrating.tsx';

// I promise I am being a good developer and not cheating the VC system. This component is strictly for development use
// only and cannot affect VC for customers.
const attrKey = 'vc-nvs';
const IGNORE_VC_ATTRIBUTE = {
	[`data-${attrKey}`]: true,
};

export const HydrationAdvisory = () => {
	const [isAdvisoryVisible, setIsAdvisoryVisible] = useState(true);
	const isHydrateRenderMode = useIsHydrateRenderMode();

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsAdvisoryVisible(false);
		}, 5000);

		return () => {
			clearTimeout(timer);
		};
	}, []);

	if (!isHydrateRenderMode) {
		return null;
	}
	return (
		<div
			{...IGNORE_VC_ATTRIBUTE}
			style={{
				position: 'absolute',
				left: 8,
				top: 12,
				display: 'flex',
				alignItems: 'center',
				// By giving this element a height of 0 and no pointer events, we ensure that it doesn't interfere with the page.
				// To make is visible again, we then set the overflow to "visible".
				height: 0,
				overflow: 'visible',
				pointerEvents: 'none',
				zIndex: 99999999,
			}}
		>
			<div
				style={{
					backgroundColor: 'aqua',
					borderRadius: '50%',
					width: 8,
					height: 8,
					zIndex: 20,
				}}
			/>

			{isAdvisoryVisible && (
				<div
					style={{
						backgroundColor: 'midnightblue',
						color: 'aqua',
						height: '1.5em',
						marginLeft: -12,
						paddingLeft: 16,
						paddingRight: 8,
						borderRadius: 4,
						zIndex: 10,
					}}
					// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
				>
					Rendered with React hydration 🚰 go/jira-hydration
				</div>
			)}
		</div>
	);
};
